import React, { useMemo } from "react";
import { BiUser } from "react-icons/bi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";
import { getPosts, getPostById, blogImageUrl } from "../utils/blogs";
import { markdownToHtml } from "../utils/markdown";

const SingleBlogs = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // No id -> show the first post; unknown id -> not found message.
  const post = id ? getPostById(id) : getPosts()[0];
  const html = useMemo(() => (post ? markdownToHtml(post.content) : ""), [post]);

  if (!post) {
    return (
      <div id="single-blog" className="section-padding single-blog">
        <div className="container text-center">
          <h2 className="display-6 single-blog__title">Blog post not found</h2>
          <p>We couldn't find the post you were looking for.</p>
          <Link to="/all-blog" className="btn btn-primary">
            Back to all blogs
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div id="single-blog" className="section-padding single-blog">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <article>
              <img
                className="img-fluid"
                src={blogImageUrl(post.image)}
                alt={post.title}
              />

              <ul className="single-blog__metainfo">
                {/* <li>
                  <BiUser />
                  <span>{post.author}</span>
                </li> */}
                <li>
                  <Link to="/all-blog" className="btn btn-primary">
                  &lt; back
                  </Link>
                </li>
                <li>
                  <FaRegCalendarAlt />
                  <span>{post.date}</span>
                </li>
              </ul>
              <h2 className="display-5 single-blog__title">{post.title}</h2>
              <div
                className="single-blog__para"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </article>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleBlogs;
